import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/HomeLayout.vue'),
    children: [
      { path: '', component: () => import('@/pages/Index.vue') }
    ]
  },
  {
    path: '/cars',
    component: () => import('@/layouts/ContentLayout.vue'),
    children: [
      { path: '', component: () => import('@/pages/Cars.vue') }
    ]
  },
  {
    path: '/design',
    component: () => import('@/layouts/ContentLayout.vue'),
    children: [
      { path: '', component: () => import('@/pages/Design.vue') }
    ]
  },
  {
    path: '/development',
    component: () => import('@/layouts/ContentLayout.vue'),
    children: [
      { path: '', component: () => import('@/pages/Development.vue') }
    ]
  },
  {
    path: '/entertainment',
    component: () => import('@/layouts/ContentLayout.vue'),
    children: [
      { path: '', component: () => import('@/pages/Entertainment.vue') }
    ]
  },
  {
    path: '/finance',
    component: () => import('@/layouts/ContentLayout.vue'),
    children: [
      { path: '', component: () => import('@/pages/Finance.vue') }
    ]
  },
  {
    path: '/news',
    component: () => import('@/layouts/ContentLayout.vue'),
    children: [
      { path: '', component: () => import('@/pages/News.vue') }
    ]
  },
  {
    path: '/sports',
    component: () => import('@/layouts/ContentLayout.vue'),
    children: [
      { path: '', component: () => import('@/pages/Sports.vue') }
    ]
  },
  {
    path: '/technology',
    component: () => import('@/layouts/ContentLayout.vue'),
    children: [
      { path: '', component: () => import('@/pages/Technology.vue') }
    ]
  },
  {
    path: '/work',
    component: () => import('@/layouts/ContentLayout.vue'),
    children: [
      { path: '', component: () => import('@/pages/Work.vue') }
    ]
  }
]

export default new Router({
  routes,
  //mode: 'history',
  hash: false
})